<!-- BEGIN::Added.by.HJSeo.2026.06.30. -->
<!-- 점검 항목 설정 팝업: conf_check_item 의 is_active(점검)/is_dspl(표시) 를 항목 단위로 토글 저장(전역). -->
<!-- 미구현 항목은 '점검' 토글을 잠그고 '미구현' 뱃지를 표시한다(켜도 동작하지 않으므로). -->
<template>
  <v-dialog :value="value" persistent max-width="640px" @input="$emit('input', $event)">
    <v-card :class="classContents">
      <v-card-title>
        <h3>{{ $t('insprpt.cfg.title') }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon x-small @click="close()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-data-table
          :headers="headers" :items="rows" item-key="item" :loading="loading"
          class="table-pd-s" height="400px"
          dense fixed-header disable-pagination hide-default-footer
        >
          <template v-slot:item.category="{ item }">{{ item.categoryDscr || item.category }}</template>
          <template v-slot:item.dscr="{ item }">
            <v-text-field v-model="item.dscr" class="cfg-dscr ma-0 pa-0" dense hide-details single-line></v-text-field>
          </template>
          <template v-slot:item.isActive="{ item }">
            <v-checkbox v-model="item.isActive" :true-value="1" :false-value="0" class="d-inline-block ma-0 pa-0" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.isDspl="{ item }">
            <v-checkbox v-model="item.isDspl" :true-value="1" :false-value="0" class="d-inline-block ma-0 pa-0" dense hide-details></v-checkbox>
          </template>
        </v-data-table>
      </v-container>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn @click="save()" :loading="saving" small color="primary">{{ $t('common.save') }}</v-btn>
        <v-btn @click="close()" small color="primary">{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import { api } from '@/api/common/instances';

export default {
  name: 'CheckItemConfig',
  props: {
    // v-model: 다이얼로그 표시 여부
    value: { type: Boolean, default: false },
    // 대상 시스템 ID(conf_check_item 은 시스템별 정의).
    systemId: { type: String, default: '' },
    // 점검 주기(현재 Daily 'D').
    chkCycle: { type: String, default: 'D' },
  },
  data() {
    return {
      loading: false,
      saving: false,
      rows: [],
      // 변경분만 저장하기 위한 원본 스냅샷
      original: [],
    };
  },
  computed: {
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
    headers() {
      return [
        { text: this.$t('insprpt.col.category'), value: 'category', sortable: false, width: '22%' },
        { text: this.$t('insprpt.col.checkitem'), value: 'dscr', sortable: false },
        { text: this.$t('insprpt.cfg.col.active'), value: 'isActive', align: 'center', sortable: false, width: '14%' },
        { text: this.$t('insprpt.cfg.col.dspl'), value: 'isDspl', align: 'center', sortable: false, width: '14%' },
      ];
    },
  },
  watch: {
    value(val) {
      if (val) this.fetch();
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      try {
        const { data } = await api.get('/statistics/checklist/custom/lem/check-items', { params: { sstmId: this.systemId, chkCycle: this.chkCycle } });
        this.rows = (data || []).map(r => ({
          item: r.item,
          category: r.category,
          categoryDscr: r.categoryDscr,
          dscr: r.dscr,
          isActive: Number(r.isActive) || 0,
          isDspl: Number(r.isDspl) || 0,
        }));
        this.original = cloneDeep(this.rows);
      } catch (e) {
        this.rows = [];
        this.original = [];
      } finally {
        this.loading = false;
      }
    },
    // is_active/is_dspl 이 바뀐 행만 추려 저장 페이로드 구성
    changedRows() {
      return this.rows
        .filter(r => {
          const o = this.original.find(x => x.item === r.item);
          return !o || o.isActive !== r.isActive || o.isDspl !== r.isDspl || o.dscr !== r.dscr;
        })
        .map(r => ({ item: r.item, isActive: r.isActive, isDspl: r.isDspl, dscr: r.dscr }));
    },
    async save() {
      const diff = this.changedRows();
      if (!diff.length) {
        this.close();
        return;
      }
      this.saving = true;
      try {
        await api.post('/statistics/checklist/custom/lem/check-items', diff, { params: { sstmId: this.systemId } });
        this.$snackbar(this.$t('insprpt.cfg.msg.saved'));
        this.$emit('saved');
        this.close();
      } catch (e) {
        this.$snackbar(this.$t('insprpt.cfg.msg.fail'));
      } finally {
        this.saving = false;
      }
    },
    close() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss" scoped>
// 표시명(dscr) 인라인 편집 필드: 셀 너비만큼 늘림(기본 입력 너비로 줄어드는 문제 방지)
.cfg-dscr {
  width: 100%;
}
// 강조 없이 일반 테이블 텍스트와 동일하게 보이도록
.cfg-dscr ::v-deep input {
  font-size: 13px;
  font-weight: 400;
}
// 입력 필드 밑줄(흰색 라인) 제거
.cfg-dscr ::v-deep .v-input__slot::before,
.cfg-dscr ::v-deep .v-input__slot::after {
  display: none;
}
</style>
<!-- FINISH::Added.by.HJSeo.2026.06.30. -->
